import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { useCurrentUserQuery } from "src/context/api/auth";

export default function NavigationTracker() {
    const location = useLocation();
    const { data: user, isLoading } = useCurrentUserQuery();

    useEffect(() => {
        if (isLoading) return;
        if (!user) return;
        if (!location.pathname) return;

        const distinctId = mixpanel.get_distinct_id();
        const userId = String(user.id);

        if (distinctId !== userId) {
            mixpanel.identify(userId);
        }

        // 👉 TRACK ICI
        mixpanel.track("Page Viewed", {
            path: location.pathname,
            role: user.role,
            userId: user.id,
        });

    }, [location, user, isLoading]);

    return null;
}
